import { computed } from '@vue/composition-api';

import type { Company } from '@/modules/advisor-search/api/useUsersApi';

const formatPeriod = (
  startDate: string,
  endDate: string,
  isCurrent: boolean,
) => {
  const start = startDate;
  const end = isCurrent ? '現在' : endDate;
  return start + (end ? ` - ${end}` : '');
};

export const useAdvisorSearchUserCompany = (props: { company: Company }) => {
  const period = computed(() =>
    formatPeriod(
      props.company.position.startDate,
      props.company.position.endDate,
      props.company.position.isCurrent,
    ),
  );

  return {
    period,
  };
};
